<template>
  <div>
    <m-dropdown
      v-model:value="visible"
      :title="$t('listSorter.title')"
      placement="bottomCenter"
    >
      <view-toolbar-chip-trigger
        :icon="icon"
        :has-value="value.length > 0"
        :has-unsaved-changes="hasUnsavedChanges"
        :disabled="disabled"
      >
        {{ label }}
      </view-toolbar-chip-trigger>
      <template #overlay>
        <m-card
          class="_overlay"
          padding-xs
        >
          <m-tooltip
            :disabled="!disabled"
            :mouse-enter-delay=".5"
          >
            <sorter-builder
              :value="value"
              :sort-options="sortOptions"
              :disabled="disabled"
              @input="update"
            />
            <template #title>
              {{ $t('savedViewInfo.disabledInfo') }}
            </template>
          </m-tooltip>
        </m-card>
      </template>
    </m-dropdown>
  </div>
</template>

<script>
import SorterBuilder from '@/components/sorter/SorterBuilder.vue';
import ViewToolbarChipTrigger from '@/components/list/ViewToolbarChipTrigger.vue';
import useSorterOptions from '@/composables/sort/sorter-options';

export default {
  name: 'SorterChips',
  props: {
    value: {
      type: Array,
      required: true,
    },
    sortOptions: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasUnsavedChanges: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  setup() {
    const { optionIcon, optionLabel } = useSorterOptions();
    return { optionIcon, optionLabel };
  },
  components: { ViewToolbarChipTrigger, SorterBuilder },
  data() {
    return { visible: false };
  },
  computed: {
    icon() {
      if (this.value.length === 1) {
        return this.value[0].desc ? 'order-down' : 'order-up';
      }
      return 'order';
    },
    label() {
      if (this.value.length === 1) {
        return this.optionLabel(this.value[0]);
      }
      return `${this.value.length} ${this.$t('sorterChips.sorts')}`;
    },
  },
  methods: {
    update(value) {
      this.$emit('input', value);
    },
    showDropdown() {
      this.visible = true;
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">

._btn {
  margin: auto 0;
}

._overlay {
  min-width: 35rem;
  max-width: 64rem;

  ._info {
    margin-bottom: 1.2rem;
  }
}
</style>
